import { listEstatesRoutine, createEstateRoutine, updateEstateRoutine, deleteEstateRoutine } from 'ducks/estates/actions'
import { emptyEstatesState } from 'ducks/estates/state'

export default (state = emptyEstatesState, action) => {
  switch (action.type) {
    case listEstatesRoutine.REQUEST:
      return { ...state, loading: true }
    case listEstatesRoutine.SUCCESS: {
      const incoming = action.payload?.data || []
      const meta = action.payload?.meta || {}
      const page = action.payload?.page || 1
      return {
        ...state,
        loading: false,
        list: page > 1 ? [...state.list, ...incoming] : incoming,
        meta: {
          currentPage: meta.currentPage || page,
          lastPage: meta.lastPage || 1,
          total: meta.total || incoming.length,
        },
      }
    }
    case listEstatesRoutine.FAILURE:
      return { ...state, loading: false }
    case createEstateRoutine.REQUEST:
    case updateEstateRoutine.REQUEST:
    case deleteEstateRoutine.REQUEST:
      return { ...state, saving: true }
    case createEstateRoutine.SUCCESS:
    case createEstateRoutine.FAILURE:
    case updateEstateRoutine.SUCCESS:
    case updateEstateRoutine.FAILURE:
    case deleteEstateRoutine.SUCCESS:
    case deleteEstateRoutine.FAILURE:
      return { ...state, saving: false }
    default:
      return state
  }
}
